/**
 * Buttons settings to generate atomic classes.
 *
 * WARNING!!! `key` are required.
 * Other are used in iCMS
 */
const button = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'button', title: 'Button' },
    { key: 'button-1', title: 'Button 1' },
    { key: 'button-2', title: 'Button 2', sgClass: 'bg-col-42' },
    { key: 'button-3 button-size-1', title: 'Button 3' },
    { key: 'button-4', title: 'Button 4' },
    { key: 'button-inline', title: 'Button Inline' },
    { key: 'button-inline-1', title: 'Button Inline 1' },
    { key: 'button-inline-2', title: 'Button Inline 2' },
    { key: 'button-inline-3', title: 'Button Inline 3' },
    { key: 'button-inline-4', title: 'Button Inline 4' },
    { key: 'button-inline-5', title: 'Button Inline 5' }
];
exports.button = button;
